const MuiCardContent = {
  styleOverrides: {
    root: {},
  },
  variants: [
    {
      props: { variant: 'create' },
      style: {
        ':last-child': { paddingBottom: 0 },
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        gridRowGap: 16,
        padding: 'initial',
      },
    },
    {
      props: { variant: 'loading' },
      style: {
        display: 'flex',
        flexDirection: 'column',
      },
    },
  ],
};

export default MuiCardContent;
